import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatRipple } from '@angular/material/core';
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle
} from '@angular/material/dialog';
import { map } from 'rxjs/operators';
import { TestIdDirective } from '../../directives/test-id.directive';
import * as testIds from '../testIds';
import {
  CategoryGridItem,
  CategoryGridStoreService
} from './category-grid-store.service';
import { GridBreadcrumbComponent } from './grid-breadcrumb/grid-breadcrumb.component';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-category-grid-item-selection',
  templateUrl: './category-grid-item-selection.component.html',
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    GridBreadcrumbComponent,
    NgIf,
    NgFor,
    TestIdDirective,
    NgClass,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    AsyncPipe,
    MatRipple,
    MatIcon
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      :host {
        width: 100%;
      }
    `
  ]
})
export class CategoryGridItemSelectionComponent implements AfterViewInit {
  items$ = this.store.items$.pipe(
    map((items) => {
      return items.map((item) => {
        const shouldBeDisabled =
          item.enabled === false && this.disableCurrentlyUnavailableItems;
        item.enabled = shouldBeDisabled === false;
        return item;
      });
    })
  );
  showParentButton$ = this.store.breadcrumb$.pipe(
    map((breadcrumb) => breadcrumb.length > 0)
  );
  noItems$ = this.items$.pipe(map((items) => items.length === 0));
  testIds = testIds;
  loading$ = this.store.loading$;
  @Input() disableCurrentlyUnavailableItems = true;
  @Input() set productType(value: 'hire' | 'retail') {
    this.store.setProductType(value);
  }
  @Output() itemSelected = new EventEmitter<CategoryGridItem>();

  constructor(private store: CategoryGridStoreService) {}

  selectItem(item: CategoryGridItem) {
    this.itemSelected.emit(item);
    this.store.selectGridItem(item);
  }

  goToParentCategory() {
    this.store.jumpToParent();
  }

  ngAfterViewInit(): void {
    this.store.getAndCacheCategories();
  }
}
